import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ spacing, breakpoints, palette }) => ({
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(6),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  subHeader: {
    margin: spacing(1),
    fontSize: spacing(3.5),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(1),
    },
  },
  image: { width: '200px', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' },
  confirmButton: {
    marginTop: spacing(1),
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    width: spacing(15),
    margin: spacing(2),
    letterSpacing: '0px',
    textTransform: 'unset',
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
  },
}));
